/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientiResponseDTO
 */
export interface ClientiResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientiResponseDTO
     */
    idCliente?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientiResponseDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientiResponseDTO
     */
    indirizzoBreve?: string | null;
}

/**
 * Check if a given object implements the ClientiResponseDTO interface.
 */
export function instanceOfClientiResponseDTO(value: object): value is ClientiResponseDTO {
    return true;
}

export function ClientiResponseDTOFromJSON(json: any): ClientiResponseDTO {
    return ClientiResponseDTOFromJSONTyped(json, false);
}

export function ClientiResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientiResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idCliente': json['idCliente'] == null ? undefined : json['idCliente'],
        'ragioneSociale': json['ragioneSociale'] == null ? undefined : json['ragioneSociale'],
        'indirizzoBreve': json['indirizzoBreve'] == null ? undefined : json['indirizzoBreve'],
    };
}

export function ClientiResponseDTOToJSON(json: any): ClientiResponseDTO {
    return ClientiResponseDTOToJSONTyped(json, false);
}

export function ClientiResponseDTOToJSONTyped(value?: ClientiResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idCliente': value['idCliente'],
        'ragioneSociale': value['ragioneSociale'],
        'indirizzoBreve': value['indirizzoBreve'],
    };
}

